import React, { useState } from "react";
import PaymentDetails from "./PaymentDetails.js";
import { ChevronDown } from "lucide-react"; // npm install lucide-react
import { FiBox, FiTag } from "react-icons/fi";

const PackageDetails = ({ Address }) => {
  const [products, setProducts] = useState([
    { id: 1, name: "", sku: "", unitPrice: "" },
  ]);
  const [deadWeight, setDeadWeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCommodityId, setSelectedCommodityId] = useState(null);
  const [dimensions, setDimensions] = useState({
    length: "",
    width: "",
    height: "",
  });

  

  const [packageList, setPackageList] = useState([
    {
      id: 1,
      deadWeight: "",
      noOfBox: "",
      weightPerBox: "",
      dimensions: { length: "", width: "", height: "" },
    },
  ]);

  // const REACT_APP_BACKEND_URL=process.env.REACT_APP_BACKEND_URL

  const handlePackageChange = (id, field, value, dimensionField = null) => {
    setPackageList((prevList) =>
      prevList.map((pkg) =>
        pkg.id === id
          ? dimensionField
            ? {
                ...pkg,
                dimensions: {
                  ...pkg.dimensions,
                  [dimensionField]: value.replace(/[^0-9.]/g, ""),
                },
              }
            : { ...pkg, [field]: value.replace(/[^0-9.]/g, "") }
          : pkg
      )
    );
  };

  // Handle dimension input changes for top-level dimensions state (unchanged)
  const handleDimensionChange = (e) => {
    const { name, value } = e.target;
    setDimensions((prev) => ({
      ...prev,
      [name]: value.replace(/[^0-9.]/g, ""), // Allow numbers and decimal points only
    }));
  };

  const [showAdditionalFees, setShowAdditionalFees] = useState(false);

  // Product functions (add, remove, qty change etc.) remain unchanged
  const addProduct = () => {
    setProducts([
      ...products,
      {
        id: products.length + 1,
        quantity: 1,
        name: "",
        sku: "",
        unitPrice: "",
      },
    ]);
  };

  const addPackage = () => {
    setPackageList([
      ...packageList,
      {
        id: packageList.length + 1,
        deadWeight: "",
        noOfBox: "",
        weightPerBox: "",
        dimensions: { length: "", width: "", height: "" },
      },
    ]);
  };

  const removePackage = (id) => {
    setPackageList(packageList.filter((pkg) => pkg.id !== id));
  };

  const removeProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };


  const handleInputChange = (id, field, value) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, [field]: value } : product
      )
    );
  };

  // Calculate volumetric weight for top-level dimensions (unchanged)
  const calculateVolumetricWeight = () => {
    const { length, width, height } = dimensions;
    if (!length || !width || !height) return "0.00";
    return ((length * width * height) / 5000).toFixed(2);
  };

  // --- UPDATED: Calculate volumetric weight per package in packageList
  const calculateVolumetricWeightForPackage = (pkg) => {
    const { length, width, height } = pkg.dimensions;
    if (!length || !width || !height) return "0.00";
    return ((length * width * height) / 5000).toFixed(2);
  };

  // Calculate total volumetric weight from all packages
  const totalVolumetricWeight = packageList.reduce(
    (sum, pkg) => sum + Number(calculateVolumetricWeightForPackage(pkg)),
    0
  );

  // Calculate total dead weight from all packages
  const totalDeadWeight = packageList.reduce(
    (sum, pkg) => sum + (Number(pkg.deadWeight) || 0),
    0
  );

  // Calculate applicable weight from packageList totals (minimum 0.5)
  const applicableWeight = Math.max(totalDeadWeight, totalVolumetricWeight, 0.5);

  // Calculate top-level volumetric weight (can be used as fallback)
  const topLevelVolumetricWeight = calculateVolumetricWeight();

  // Calculate total price for all products (unchanged)
const totalPrice = products.reduce((total, product) => {
  const unitPrice = parseFloat(product.unitPrice) || 0;
  return total + unitPrice;
}, 0);

const totalNoOfBoxes = packageList.reduce(
  (sum, pkg) => sum + (Number(pkg.noOfBox) || 0),
  0
);

  // Combine all data to pass to PaymentDetails with updated packageList containing volumetric weight per package
  const packageData = {
    volumetricWeight: totalVolumetricWeight.toFixed(2),
    applicableWeight: applicableWeight.toFixed(2),
    products,
    address: Address,
    totalPrice,
    packageList: packageList.map((pkg) => ({
      ...pkg,
      deadWeight: Number(pkg.deadWeight) || 0,
      noOfBox: Number(pkg.noOfBox) || 0,
      weightPerBox: Number(pkg.weightPerBox) || 0,
      volumetricWeight: Number(calculateVolumetricWeightForPackage(pkg)) || 0,
    })),
    totalNoOfBoxes,
  };

  console.log(packageData, "thisn i");

  // UI and JSX remain unchanged except volumetric weight uses updated calculation for packageList

  return (
    <div className="max-w-full mx-auto ">
      <div className="border rounded-xl  p-2 md:p-5 bg-white border-[#0CBB7D] hover:shadow-sm transition-shadow">
        <h2  className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-4 text-center md:text-left flex items-center gap-2">
          <span className="bg-[#0CBB7D] text-white rounded-lg p-2 md:p-2">
            <FiTag className="text-[12px] md:text-[16px]" />
          </span>
          Product Details
        </h2>
        {/* import { ChevronDown } from "lucide-react"; */}

        {products.map((product, index) => (
          <div
            key={product.id}
            className="border border-dashed border-[#0CBB7D] rounded-lg p-4 mb-6 relative bg-white"
          >
            {/* Index Badge */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#0CBB7D] text-white px-3 py-1 rounded-full text-sm font-semibold shadow">
              {index + 1}
            </div>

            {/* Delete Icon Button */}
            <div className="absolute -top-4 right-4 group">
              <button
                onClick={() => removeProduct(product.id)}
                className="w-9 h-9 flex items-center justify-center bg-[#FFE3DC] hover:bg-[#FFD5C9] text-[#F1572C] rounded-full shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M3 6h18v2H3V6zm2 3h14l-1.5 12.5a1 1 0 0 1-1 .5H7a1 1 0 0 1-1-.5L4 9zm5 2v8h2v-8H9zm4 0v8h2v-8h-2z" />
                </svg>
              </button>
              {/* Tooltip */}
              <div className="absolute left-1/2 z-50 -translate-x-1/2 top-full mt-1 px-2 py-1 text-[#F1572C] text-xs rounded shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                Delete
              </div>
            </div>

            {/* Top Row Fields */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="font-[600] text-[12px] text-black mb-1 block">
                  Product Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Product Name"
                  value={product.name}
                  onChange={(e) =>
                    handleInputChange(product.id, "name", e.target.value)
                  }
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] placeholder:text-[12px] placeholder:font-[400] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                />
              </div>
              <div>
                <label className="font-[600] text-[12px] text-black mb-1 block">
                  SKU
                </label>
                <input
                  type="text"
                  placeholder="SKU"
                  value={product.sku}
                  onChange={(e) =>
                    handleInputChange(product.id, "sku", e.target.value)
                  }
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] placeholder:text-[12px] placeholder:font-[400] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                />
              </div>
              
              <div>
                <label className="font-[600] text-[12px] text-black mb-1 block">
                  Invoice Value <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-2.5 text-[12px] font-[400] text-gray-500">
                    ₹
                  </span>
                  <input
                    type="text"
                    placeholder="Invoice Value"
                    value={product.unitPrice}
                    onChange={(e) =>
                      handleInputChange(product.id, "unitPrice", e.target.value)
                    }
                    className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                  />
                </div>
              </div>
            </div>

            {/* Toggle Optional Fields */}
            <div
              className="mt-4 flex items-center space-x-1 cursor-pointer text-sm"
              onClick={() => setShowAdditionalFees(!showAdditionalFees)}
            >
              <span className="text-[#0CBB7D] hover:underline text-[12px] font-[600]">
                + Add Category, HSN, Discount and Tax
              </span>
              <span className="text-xs text-gray-500">(optional)</span>
            </div>

            {/* Optional Fields */}
            {showAdditionalFees && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                <div>
                  <label className="font-[600] text-[12px] text-black mb-1 block">
                    Product Category
                  </label>
                  <input
                    type="text"
                    placeholder="Product Category"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                  />
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-black mb-1 block">
                    HSN
                  </label>
                  <input
                    type="text"
                    placeholder="Enter HSN"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                  />
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-black mb-1 block">
                    Discount
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-2.5 text-[12px] text-gray-500">
                      ₹
                    </span>
                    <input
                      type="number"
                      placeholder="Discount"
                      className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                    />
                  </div>
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-black mb-1 block">
                    Tax
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-2.5 text-[12px] text-gray-500">
                      ₹
                    </span>
                    <input
                      type="number"
                      placeholder="Tax"
                      className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Add Product Button */}
        <button
          onClick={addProduct}
          className="flex items-center justify-center w-8 h-8 bg-[#0CBB7D] text-white rounded-full mx-auto text-2xl hover:bg-[#099f69]"
        >
          +
        </button>
      </div>

      {/* Package Details */}
      <div className="border mt-5 border-[#0CBB7D] rounded-xl p-2 md:p-5 bg-white hover:shadow-lg transition-shadow">
        <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-2 text-center md:text-left flex items-center gap-2">
          <span className="bg-[#0CBB7D] text-white rounded-lg p-2 md:p-2">
            <FiBox className="text-[12px] md:text-[16px]" />
          </span>
          Package Details
        </h2>

        {/* Inputs in One Line */}
        {packageList.map((pkg, index) => (
          <div
            key={pkg.id}
            className="flex flex-col sm:flex-wrap sm:flex-row items-start sm:items-center gap-4 sm:gap-8 bg-white p-3 rounded-lg shadow-sm relative mb-4 border border-dashed border-[#0CBB7D]"
          >
            {/* Index Badge */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#0CBB7D] text-white px-3 py-1 rounded-full text-sm font-semibold shadow">
              {index + 1}
            </div>

            {/* Delete Button */}
            {packageList.length > 1 && (
              <button
                onClick={() => removePackage(pkg.id)}
                className="absolute -top-4 right-4 w-9 h-9 flex items-center justify-center bg-[#FFE3DC] hover:bg-[#FFD5C9] text-[#F1572C] rounded-full shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M3 6h18v2H3V6zm2 3h14l-1.5 12.5a1 1 0 0 1-1 .5H7a1 1 0 0 1-1-.5L4 9zm5 2v8h2v-8H9zm4 0v8h2v-8h-2z" />
                </svg>
              </button>
            )}

            {/* Dead Weight */}
            <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto">
              <label className="font-[600] text-[12px] text-black">Dead Weight:</label>
              <div className="flex items-center border rounded-md w-full sm:w-24">
                <input
                  type="text"
                  value={pkg.deadWeight}
                  onChange={(e) =>
                    handlePackageChange(pkg.id, "deadWeight", e.target.value)
                  }
                  className="w-full h-9 px-2 text-sm border-none rounded-l-md"
                  placeholder="0.00"
                />
                <span className="w-12 h-9 flex justify-center items-center text-sm text-white rounded-r-md bg-[#0CBB7D]">
                  kg
                </span>
              </div>
            </div>

            {/* No. of Box */}
            <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto">
              <label className="font-[600] text-[12px] text-black">No. of Box:</label>
              <div className="flex items-center border rounded-md w-full sm:w-24">
                <input
                  type="text"
                  value={pkg.noOfBox}
                  onChange={(e) =>
                    handlePackageChange(pkg.id, "noOfBox", e.target.value)
                  }
                  className="w-full h-9 px-2 text-sm border-none rounded-md"
                  placeholder="0"
                />
              </div>
            </div>

            {/* Weight Per Box */}
            <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto">
              <label className="font-[600] text-[12px] text-black">Weight Per Box:</label>
              <div className="flex items-center border rounded-md w-full sm:w-24">
                <input
                  type="text"
                  value={pkg.weightPerBox}
                  onChange={(e) =>
                    handlePackageChange(pkg.id, "weightPerBox", e.target.value)
                  }
                  className="w-full h-9 px-2 text-sm border-none rounded-l-md"
                  placeholder="0.00"
                />
                <span className="w-12 h-9 flex justify-center items-center text-sm text-white rounded-r-md bg-[#0CBB7D]">
                  kg
                </span>
              </div>
            </div>

            {/* Dimensions */}
            <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto mt-3">
              <label className="font-[600] text-[12px] text-black mb-1">Dimensions:</label>
              <div className="flex flex-wrap gap-2 sm:gap-4 mb-2 w-full">
                {["length", "width", "height"].map((dim) => (
                  <div
                    key={dim}
                    className="flex items-center border rounded-md w-full sm:w-24"
                  >
                    <input
                      type="text"
                      value={pkg.dimensions[dim]}
                      onChange={(e) =>
                        handlePackageChange(
                          pkg.id,
                          "dimensions",
                          e.target.value,
                          dim
                        )
                      }
                      placeholder={dim}
                      className="w-full p-2 text-sm border-none rounded-l-md"
                    />
                    <span className="w-12 h-full flex justify-center items-center text-sm text-white rounded-r-md bg-[#0CBB7D]">
                      cm
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
        <button
          onClick={addPackage}
          className="flex items-center justify-center w-8 h-8 bg-[#0CBB7D] text-white rounded-full mx-auto text-2xl hover:bg-[#099f69]"
        >
          +
        </button>

        {/* Note Section */}
        <p className="text-[12px]  font-[400] text-gray-500 mt-2">
          <span className="text-red-500"> Note: </span>Note: The minimum
          chargeable weight is <strong>0.50 Kg</strong>. Dimensions should be in{" "}
          <strong>centimeters only</strong> and values should be greater than{" "}
          <strong>0.50 cm</strong>.
        </p>

        {/* Results */}
        <div className="flex flex-col sm:flex-row gap-4 bg-white p-1 rounded-md mt-4">
          <div className="bg-green-100 shadow-md rounded-md p-4 w-full sm:w-2/4">
            <h3 className="text-[12px] font-[600] text-black">Applicable Weight</h3>
            <p className="text-[12px] font-[600] text-black">{applicableWeight.toFixed(2)} Kg</p>
            <p className="text-[12px] font-[400] text-gray-500 mt-2">
              Applicable weight is the heavier among Dead Weight vs Volumetric Weight.
            </p>
            <p className="text-[12px] font-[400] text-gray-500 mt-2">
              Final chargeable weight will be based on the weight slab of the
              courier selected.
            </p>
          </div>
          <div className="bg-green-100 shadow-md rounded-md p-4 w-full sm:w-1/2">
            <h3 className="text-[12px] font-[600] text-black">Volumetric Weight</h3>
            <p className="text-[12px]  font-[600] text-black">{totalVolumetricWeight.toFixed(2)} Kg</p>
          </div>
        </div>

        <hr className="my-4 border-t border-gray-300" />

        {/* Display Total Price */}
        <div className="bg-green-100 p-2 rounded mb-4 flex flex-col sm:flex-row sm:justify-between items-center">
          <p className="text-black text-[12px] lg:text-[12px] sm:text-[12px] font-[600]">
            Total Order Value
          </p>
          <p className="text-[12px] font-[600] text-black">₹{totalPrice}</p>
        </div>
      </div>
      <div>
        {/* Payment Details */}
        <PaymentDetails packageData={packageData} />
      </div>
    </div>
  );
};

export default PackageDetails;
